export const googleRedirectUri = () => {
    return window.location.protocol + '//' + window.location.hostname + '/google/callback'
}
